import { render, staticRenderFns } from "./SidebarNewPurchase.vue?vue&type=template&id=041310f7&"
import script from "./SidebarNewPurchase.vue?vue&type=script&lang=js&"
export * from "./SidebarNewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNewPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports